export const turnBullPages = [
  'an-affordable-solution',
  'about-freedom-debt-relief',
  'program-eligible-debts',
  'your-debt-solution',
  'how-our-program-works',
  'lets-get-started'
]
